module.exports = __webpack_public_path__ + "static/img/GA.2d7e934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GA.png
// module id = o0Vr
// module chunks = 1